import "./styles.css";
import { Game } from "./Game";
import { queryShell } from "./ui/shell";

const root = document.querySelector<HTMLElement>("#app");
if (root === null) throw new Error("Missing #app root");

// 只有一套 DOM（决策 0018 第三条）：舞台撑满，HUD 全部叠在舞台四角，三档断点同一个样子；
// 唯一随断点变的是开发期调参面板的停靠轨道 dock（横屏右列、竖屏底行），生产构建恒为 0。
// 常驻 HUD 只有三样：左上失误标记、右上按钮组、底部关卡进度；其余都是发生时才出现的叠层。
root.innerHTML = `
  <div class="shell" data-shell data-panel="closed">
    <section class="stage" data-stage aria-label="Game viewport">
      <div class="stage__frame" data-stage-frame data-testid="canvas-wrap">
        <div id="canvas-host"></div>

        <div class="hud-corner hud-corner--tl" aria-label="Leaks">
          <div class="hud-strikes" data-hud="leak-pips" aria-hidden="true"></div>
          <span class="sr-only" data-hud="leaked">0</span>
        </div>
        <nav class="hud-corner hud-corner--tr hud-icons" data-hud="controls" aria-label="Game controls">
          <button type="button" class="hud-icon" data-action="mute" aria-pressed="false" aria-label="Sound" title="Sound">♪</button>
          <button type="button" class="hud-icon" data-action="restart" aria-label="Restart" title="Restart">↻</button>
          <button type="button" class="hud-icon" data-action="pause" aria-label="Pause" title="Pause">II</button>
        </nav>

        <div class="hud-intro" data-hud="intro" hidden>
          <p class="hud-intro__level" data-hud="level">01 // SLIME SHAKE</p>
          <p class="hud-intro__rule" data-hud="intro-rule"></p>
          <p class="hud-intro__hint" data-hud="intro-hint" hidden></p>
          <p class="sr-only" data-hud="kicker"></p>
          <p class="sr-only" data-hud="objective"></p>
        </div>

        <div class="progress" data-hud="timeline" hidden aria-label="Level progress">
          <div class="progress__fill" data-hud="timeline-fill"></div>
          <div class="progress__flags" data-hud="timeline-track"></div>
          <div class="progress__marker" data-hud="timeline-head"></div>
        </div>
        <div class="wave-banner" data-hud="wave-banner" hidden><span>BIG WAVE INCOMING</span></div>

        <div class="game-overlay" data-hud="overlay" hidden>
          <div class="game-overlay__card">
            <p data-hud="overlay-eyebrow">MISSION UPDATE</p>
            <h2 data-hud="overlay-title">STAGE CLEAR</h2>
            <span data-hud="overlay-body"></span>
            <small data-hud="overlay-note" hidden></small>
            <form class="recommendation" data-hud="feedback" hidden>
              <fieldset>
                <legend>How do you like this game?</legend>
                <div class="stars">
                  ${[1, 2, 3, 4, 5]
                    .map(
                      (n) => `
                    <label><input type="radio" name="rating" value="${n}" aria-label="${n} ${n === 1 ? "star" : "stars"}" required><span aria-hidden="true">★</span></label>
                  `,
                    )
                    .join("")}
                </div>
              </fieldset>
              <button type="submit" data-action="feedback-submit" disabled>SUBMIT</button>
              <div class="recommendation__status" data-hud="feedback-status" role="status"></div>
            </form>
            <button type="button" data-action="next">NEXT STAGE</button>
          </div>
        </div>
      </div>
    </section>

    <aside class="dock" data-dock aria-label="Developer dock" hidden></aside>
  </div>
`;

const game = new Game();
void game.init(queryShell(root)).catch((error: unknown) => {
  game.destroy();
  const message = error instanceof Error ? error.message : String(error);
  root.innerHTML = `<div class="fatal-error"><strong>GAME BOOT FAILED</strong><p>${message}</p></div>`;
  throw error;
});

const pageHide = (event: PageTransitionEvent) => {
  if (!event.persisted) game.destroy("normal");
};
window.addEventListener("pagehide", pageHide);
import.meta.hot?.dispose(() => {
  window.removeEventListener("pagehide", pageHide);
  game.destroy();
});
